
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import TitleShareButton from '@/components/details/TitleShareButton.vue';

import { ShareMethod } from '@/enums/share-methods';
import { ShareHelper } from '@/helpers/share-helper';
import { ObjectType } from '@/@types/graphql-types';

@Component({
	name: 'TitleBlock',
	components: {
		TitleShareButton,
	},
})
export default class TitleBlock extends Vue {
	@Prop({ required: true }) titleId: number;
	@Prop({ required: true }) titleObjectType: ObjectType;
	@Prop({ default: '' }) titleName: string;
	@Prop({ default: '' }) originalTitleName: string;
	@Prop({ default: '' }) seasonName: string;
	@Prop({ default: '' }) titleFullPath: string;
	@Prop({ default: null }) originalReleaseYear: number;
	@Prop({ default: true }) showShare: boolean;
	@Prop({ default: '' }) metaH1Text: string;
	@Prop({ default: '' }) metaH2Text: string;

	share(method?: ShareMethod) {
		ShareHelper.share(
			{
				titleId: this.titleId,
				titleObjectType: this.titleObjectType,
				titleFullPath: this.titleFullPath,
				titleName: this.titleName,
			},
			method
		);
	}
}
